import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  hoverEffect = true,
  onClick
}: CardProps) {
  return <motion.div whileHover={hoverEffect ? {
    y: -5,
    borderColor: 'rgba(212, 168, 67, 0.3)'
  } : {}} transition={{
    duration: 0.2
  }} onClick={onClick} className={`bg-dark-400 border border-dark-300 rounded-xl overflow-hidden shadow-xl ${onClick ? 'cursor-pointer' : ''} ${className}`} data-id="element-159" data-mp="d2oi8eph0tdv">
      {children}
    </motion.div>;
}